import LoginForm from './LoginForm'

export {
  LoginForm
}



// WEBPACK FOOTER //
// ./src/views/Secure/components/index.js